import React from 'react';

const VipV3 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "17",
    viewBox: "0 0 18 17",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.09245 3.1288L5.44128 9.75681C5.36262 9.95387 5.11285 10.0127 4.95475 9.87214L0.597407 5.99756C0.52943 5.93798 0.430903 5.92729 0.352234 5.97235C0.272801 6.01665 0.231556 6.10678 0.249125 6.19614L1.79272 14.1684C1.89583 14.7031 2.11579 15.1865 2.42666 15.5234C2.73675 15.8602 3.12476 16.058 3.63116 16.058H14.0194C14.525 16.058 14.9069 15.861 15.2162 15.5234C15.5255 15.1858 15.7463 14.6992 15.857 14.1638L17.3991 6.19606C17.4167 6.1067 17.3754 6.01657 17.296 5.97228C17.2173 5.92721 17.1188 5.93791 17.0508 5.99748L12.6942 9.87207C12.5361 10.0134 12.2856 9.95379 12.207 9.75674L9.55579 3.12872C9.32283 3.19288 9.07766 3.22878 8.82408 3.22878C8.5705 3.22878 8.32616 3.19296 8.09245 3.1288ZM3.87491 4.77245L3.07217 7.3808L5.03586 9.12604L6.02953 6.64146L4.44927 4.66409C4.37289 4.56785 4.24917 4.52279 4.12925 4.5457C4.00857 4.56862 3.91081 4.65558 3.87491 4.77245ZM13.1993 4.66323L11.6182 6.63904L12.6134 9.12596L14.5771 7.38072L13.7736 4.77237C13.7377 4.65551 13.64 4.56768 13.5193 4.54552C13.3986 4.52261 13.2756 4.56776 13.1993 4.66323Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.82274 1.01392C9.29811 1.01392 9.68064 1.39733 9.68064 1.87268C9.68064 2.34802 9.29814 2.73058 8.82274 2.73058C8.34734 2.73058 7.96484 2.34808 7.96484 1.87268C7.96484 1.39728 8.34734 1.01392 8.82274 1.01392Z",
      fill: "white"
    }
  )
);

export { VipV3 };
//# sourceMappingURL=VipV3.js.map
